import SerialNumbersProvider from './SerialNumbersProvider';
import SerialNumbers from './SerialNumbers';

let Index = () => {
    return (
        <SerialNumbersProvider>
            <SerialNumbers />
        </SerialNumbersProvider>
    )
}

export default Index;